<script>
  import { AffiliateConstants, RoleName } from '@/assets/js/constants';
  import { insertAffiliate, updateAffiliate } from 'api/affiliate/overall';
  import { getAllTags } from 'api/affiliate/tag';
  import { getBindAccountListApi } from 'api/account';
  import { getUserListByRole } from 'api/user';
  import { getCompanyBankAffOption } from 'api/common/companyInfo';
  import { validateEmail } from 'utils/validator';

  export default {
    name: 'AffiliateBaseForm',
    computed: {
      AffiliateConstants() {
        return AffiliateConstants;
      },
    },
    props: {
      dialogType: {
        type: String,
        default: 'new',
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      updateData: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        affiliate: {},
        bindAccountList: [],
        amList: [],
        bdList: [],
        tagOption: [],
        companyBankList: [],
        bankList: [],
        rules: {
          companyName: [{ trigger: 'blur', required: true }],
          bankName: [{ trigger: 'blur', required: true }],
          bankAddress: [{ trigger: 'blur', required: true }],
          bankAccountName: [{ trigger: 'blur', required: true }],
          bankAccountNumber: [{ trigger: 'blur', required: true }],
          swiftCode: [{ trigger: 'blur', required: true }],
          branchCode: [{ trigger: 'blur', required: true }],
          email: [{ validator: validateEmail, trigger: 'blur', required: true }],
        },
      };
    },
    watch: {
      updateData: {
        handler(newVal) {
          this.affiliate = Object.assign({}, newVal);
        },
      },
      dialogVisible(newVal) {
        this.bankList.length = 0;
        let temp = this.companyBankList.find(
          (item) => item.bfiId === this.affiliate.bfiId && item.bankList !== undefined
        );
        if (temp && temp.length !== 0) {
          this.bankList = [...temp.bankList];
        }
        if (!newVal) {
          this.$refs.baseForm.resetFields();
        } else {
          if (this.$refs.baseForm) {
            this.$refs.baseForm.clearValidate();
          }
        }
      },
    },
    mounted() {
      this.getTagList();
      this.getBindAccountList();
      this.getPmList();
      this.getBdList();
      this.getCompanyBank();
    },
    methods: {
      getBindAccountList() {
        getBindAccountListApi()
          .then((resp) => {
            this.bindAccountList = resp.result?.map((item) => ({
              label: item.uname,
              value: item.id,
            }));
          })
          .catch(() => {
            this.bindAccountList = [];
          });
      },
      getTagList() {
        getAllTags()
          .then((resp) => {
            this.tagOption = resp.result?.map((item) => ({
              label: item.trafficTag,
              value: item.trafficTag,
            }));
          })
          .catch(() => {
            this.tagOption = [];
          });
      },
      handleSubmit() {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            if (this.dialogType === 'new') {
              insertAffiliate({ ...this.affiliate }).then(() => {
                this.$message({
                  message: 'Add Update',
                  type: 'success',
                });
                this.$emit('refresh-list');
                this.handleClose();
              });
            } else if (this.dialogType === 'edit') {
              updateAffiliate({ ...this.affiliate }).then(() => {
                this.$message({
                  message: 'Update Success',
                  type: 'success',
                });
                this.$emit('refresh-list');
                this.handleClose();
              });
            }
          } else {
            return false;
          }
        });
      },
      handleCompanyEntity(value) {
        if (value === '') {
          return;
        }
        this.bankList.length = 0;
        this.affiliate.bfbId = null;
        let temp = this.companyBankList.find(
          (item) => item.bfiId === value && item.bankList !== undefined
        );
        if (temp && temp.length !== 0) {
          this.bankList = [...temp.bankList];
        }
      },
      getCompanyBank() {
        getCompanyBankAffOption().then((res) => {
          if (res.result) {
            this.companyBankList = res.result;
          }
        });
      },
      getPmList() {
        getUserListByRole(RoleName.AM)
          .then((response) => {
            if (response.result) {
              this.amList = response.result.map((item) => ({
                label: item.uname,
                value: item.id,
              }));
            }
          })
          .catch(() => {});
      },
      getBdList() {
        getUserListByRole(RoleName.BD)
          .then((response) => {
            if (response.result) {
              this.bdList = response.result.map((item) => ({
                label: item.uname,
                value: item.id,
              }));
            }
          })
          .catch(() => {});
      },
      handleBdSelectChange(value) {
        const option = this.bdList.find((item) => item.value === value);
        if (option) {
          this.affiliate.bdName = option.label;
        }
      },
      handleAmSelectChange(value) {
        const option = this.amList.find((item) => item.value === value);
        if (option) {
          this.affiliate.amName = option.label;
        }
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
      },
    },
  };
</script>

<template>
  <el-dialog
    :title="dialogType === 'new' ? 'Affiliate Create' : 'Affiliate Update'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="65%"
    @close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="180px"
      ref="baseForm"
      :model="affiliate"
      :rules="rules"
      class="grid-form"
    >
      <el-form-item label="Name" prop="company" required>
        <el-input v-model="affiliate.company" placeholder="Name" />
      </el-form-item>
      <el-form-item label="Email" prop="email" required>
        <el-input v-model="affiliate.email" placeholder="Name" />
      </el-form-item>

      <el-form-item label="Description" prop="description" required>
        <el-input v-model="affiliate.description" placeholder="description" />
      </el-form-item>
      <el-form-item label="Postback Url">
        <el-input v-model="affiliate.postbackUrl" placeholder="postback url here..." />
      </el-form-item>
      <el-form-item label="EventPbUrl">
        <el-input v-model="affiliate.eventPbUrl" placeholder="event Pb url here..." />
      </el-form-item>
      <el-form-item label="Company Entity" prop="bfiId" required>
        <el-select
          v-model="affiliate.bfiId"
          placeholder="please input"
          filterable
          clearable
          @change="handleCompanyEntity"
        >
          <el-option
            v-for="item in companyBankList"
            :value="item.bfiId"
            :label="item.companyEntity"
            :key="item.bfiId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Bank Account Name" prop="bfbId">
        <el-select v-model="affiliate.bfbId" clearable filterable placeholder="please input">
          <el-option
            v-for="item in bankList"
            :value="item.bankId"
            :key="item.bankId"
            :label="item.bankAccountName"
          >
            {{ item.bankAccountName }}
            <el-tag style="margin-left: 5px" v-for="(tag, index) in item.bankTags" :key="index"
              >{{ tag }}
            </el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="AM" prop="amId" required>
        <el-select
          v-model="affiliate.amId"
          filterable
          placeholder="请选择"
          @change="handleAmSelectChange"
        >
          <el-option
            v-for="item in amList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="BD" prop="bdId" required>
        <el-select
          v-model="affiliate.bdId"
          filterable
          placeholder="请选择"
          @change="handleBdSelectChange"
        >
          <el-option
            v-for="item in bdList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="RejectPbUrl">
        <el-input v-model="affiliate.rejectPbUrl" placeholder="reject event Pb url here..." />
      </el-form-item>
      <el-form-item label="Traffic Type" prop="trafficType" required>
        <el-select v-model="affiliate.trafficType" filterable placeholder="Traffic Type">
          <el-option
            v-for="item in AffiliateConstants.trafficType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Level">
        <el-select v-model="affiliate.level" filterable placeholder="Level">
          <el-option
            v-for="item in AffiliateConstants.levelOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Adjusted Enable" prop="adjusted" required>
        <el-select v-model="affiliate.adjusted" filterable placeholder="Adjusted Enable">
          <el-option
            v-for="item in AffiliateConstants.offerMonitor"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="ClickLimited" prop="crBlackLimited">
        <el-select v-model="affiliate.crBlackLimited" filterable>
          <el-option
            v-for="item in AffiliateConstants.clickLimiteOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Track Domain">
        <el-input v-model="affiliate.trackDomain" placeholder="track domain here..." />
      </el-form-item>
      <el-form-item label="Out Hour Adjust">
        <el-input v-model="affiliate.outHourAdjust" placeholder="outHourAdjust url here..." />
      </el-form-item>
      <el-form-item label="BlackByCrClicks" prop="crBlackClicks">
        <el-input v-model="affiliate.crBlackClicks" />
      </el-form-item>
      <el-form-item label="Traffic Tag" prop="trafficTag">
        <el-select v-model="affiliate.trafficTag" clearable filterable placeholder="status">
          <el-option
            v-for="item in tagOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Authorised" prop="bindAccountId" v-if="dialogType === 'new'" required>
        <el-select v-model="affiliate.bindAccountId" clearable filterable>
          <el-option
            v-for="item in bindAccountList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="DynamicPb" required>
        <el-select v-model="affiliate.isDynamicPb" filterable placeholder="DynamicPb">
          <el-option
            v-for="item in AffiliateConstants.isDynamicPbOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Status" prop="status">
        <el-select v-model="affiliate.status" filterable placeholder="status">
          <el-option
            v-for="item in AffiliateConstants.statusOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="DynamicPbParams" prop="dynamicPbParams">
        <el-input
          v-model="affiliate.dynamicPbParams"
          placeholder="eg. ?source=hypertap or &conv_time={conv_time}"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
